<app-header></app-header>

<div class="page-content">

  <div class="mobile-body-container">

    <div *ngIf="loading">
        <h2>Videollamada 60 minutos</h2>
        <p>Te estamos redirigiendo a nuestro Calendly para que puedas elegir la fecha y la hora de tu videollamada</p>

        <mat-spinner [diameter]="30" class="dark-button-spinner center"></mat-spinner>
        <p>Redirigiendo a Calendly...</p>
    </div>

    <!-- OTROS SERVICIOS -->
    <div *ngIf="!loading">
        <div *ngIf="expired">
            <p>{{ 'ACTIVATE_PRODUCT.ERRORS.INVALID_TOKEN' | translate }}</p>
            <p>Si es un error, puedes escribirnos a {{supportEmail}} y te activaremos de nuevo el enlace de tu producto.</p>
        </div>
        <br>
        <app-card-utility [cardInfo]="moreServices"></app-card-utility>
    </div>
    
  </div>

</div>

